/*---------------------------------------------------------*\
 * Imports
 \*---------------------------------------------------------*/
import angular from 'angular';
import keyboard from 'keycode-ui';
import PubSub from 'pubsub-js';
import _ from 'lodash';

const deps = {};

/*---------------------------------------------------------*\
 * StoryListController
 \*---------------------------------------------------------*/
class StoryListController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($timeout, $state, states, navigationService, newsService, adProps, topics) {
    deps.$state = $state;
    deps.$timeout = $timeout;
    deps.states = states;
    deps.navigationService = navigationService;
    deps.newsService = newsService;
    deps.adProps = adProps;
    deps.topics = topics;
    this.name = 'storyList';
    this.pageSize = this.pageSize || 3;
    const page = this.focusItem !== undefined ? Math.floor(this.focusItem / this.pageSize) : 0;
    this.refreshNav(page || 0);
  }

  get stories() {
    return this._stories || [];
  }

  set stories(val) {
    this._stories = val || [];
    if (this.focusItem !== undefined) {
      const page = this.focusItem !== undefined ? Math.floor(this.focusItem / this.pageSize) : 0;
      // this is just an async callback to load data. so preserve the current page
      this.refreshNav(page);
      delete this.focusItem;
    } else {
      // data has changed from old one. reset current page
      this.refreshNav(0);
    }
  }

  loadEmptyImage() {
    // when we paginate through story list. empty out the fallbackimage and delay the load of it by 100ms.
    // This allows us to not show the empty image after a slight delay.
    // this approach is significantly better then having to call each image first and
    // then load into the background image tag thus producing 2 image calls per image.
    // If image loading is slow then the UI may show the fallback image then the new image once loaded.
    this.fallbackImage = '';
    deps.$timeout(() => {
      this.fallbackImage = '/assets/images/News12EmptyImage.png';
    }, 500);
  }
  //-----------------------------------
  // Methods
  //-----------------------------------
  refreshNav(page) {
    this.currentPage = page || 0;
    this.pageFirst = this.stories.length > 0 ? Math.min(this.currentPage * this.pageSize, this.stories.length - 1) : 0;
    this.pageLast = this.stories.length > 0 ? Math.min(this.pageFirst + this.pageSize, this.stories.length) - 1 : 0;

    // load empty images if not found. Checking deps.$timeout since this function is called by the ES6 setter function
    // which runs before our dependencies are wired up
    if (deps.$timeout) {
      this.loadEmptyImage();
    }
  }

  prev() {
    const totalPages = Math.ceil(this.stories.length / this.pageSize);
    if (this.currentPage === 0) {
      this.currentPage = Math.max(0, totalPages - 1);
    } else {
      this.currentPage -= 1;
    }
    this.refreshNav(this.currentPage);
  }

  next() {
    const totalPages = Math.ceil(this.stories.length / this.pageSize);
    if (this.currentPage === totalPages - 1) {
      this.currentPage = 0;
    } else {
      this.currentPage++;
    }
    this.refreshNav(this.currentPage);
  }

  listKeyDown(e, index) {
    switch (true) {
      case keyboard.isUp(e):
        if (index > 0) {
          angular.element(e.target).parent().children()[index - 1].focus();
          e.preventDefault();
        } else {
          this.onKeydown({ event: e });
        }
        break;
      case keyboard.isDown(e):
        if (this.stories.length <= this.pageSize) {
          if (this.stories[index + 1]) {
            e.preventDefault();
            angular.element(e.target).parent().children()[index + 1].focus();
          } else {
            e.preventDefault();
            deps.navigationService.focusEl('.main-menu-btn');
          }
        }
        break;
    }
  }

  select(story, index) {
    // focusItem = global index
    const videoItem = {
      focusItem: (this.currentPage * this.pageSize) + index,
      story
    };
    this.onSelect(videoItem);
  }

  focusNav(event) {
    if (keyboard.isDown(event) || keyboard.isRight(event)) {
      const previousElement = event.target;
      PubSub.publish(deps.adProps.home.previousElement, { previousElement });
    } else if (keyboard.isLeft(event)) {
      if (_.contains(event.target.innerText, 'Prev')) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  gotoNewsHome() {
    PubSub.publish(deps.topics.headerMain.resetSubnav);
  }
}

StoryListController.$inject = [
  '$timeout',
  '$state',
  'states',
  'navigationService',
  'newsService',
  'adProps',
  'topics'
];

export default StoryListController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/storyList/storyList.controller.js
 **/